import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper, useTable } from "@components/mantine";
import { keepPreviousData, Platform, useQuery } from "@core/api";
import { GenericGranularPrivilegesTable } from "../GenericGranularPrivilegesTable.js";
import { Locales } from "../../../../strings/Locales.js";
var columnHelper = createColumnHelper();
var columns = [
    columnHelper.accessor("trackingId", {
        header: Locales.format("PrivilegesTable.Pipelines.column.name.header"),
        enableSorting: false
    })
];
export var MerchandisingHubPrivilegesTable = function(props) {
    var store = useTable();
    var query = useQuery({
        queryKey: [
            "trackingId",
            "list"
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.commerce.trackingIdLocales.list()
                        ];
                    case 1:
                        response = _state.sent();
                        store.setTotalEntries(response.items.length);
                        return [
                            2,
                            response.items
                        ];
                }
            });
        }),
        select: function(data) {
            return data.map(function(item) {
                return _object_spread_props(_object_spread({}, item), {
                    id: item.trackingId
                });
            });
        },
        placeholderData: keepPreviousData
    });
    return /*#__PURE__*/ _jsx(GenericGranularPrivilegesTable, _object_spread({
        store: store,
        columns: columns,
        query: query,
        resourceName: Locales.format("PrivilegesTable.MerchandisingHub.trackingId")
    }, props));
};

//# sourceMappingURL=MerchandisingHubPrivilegesTable.js.map